// NOTE: Avoid modifying code `401` as this is used by wallboard and permission error pages (search DASHBOARD_PERMISSION_ERROR_CODE_LIST for usages).
// Wallboard does not reference this list directly because there are import issues, so it uses `401` as a string.
export const DASHBOARD_PERMISSION_ERROR_CODE_LIST_OLD = [401, 403, 404];
export const DASHBOARD_PERMISSION_ERROR_CODE_LIST_NEW = [401, 403, 404, 429];
